// @file Utilities related to the javascript Set object.
export function findLast<T>(set: Set<T>): T | undefined {
  let lastElement: T | undefined
  for (const el of set) {
    lastElement = el
  }
  return lastElement
}
